<template>
  <div ref="madeForm">
    <avue-form :option="optionForm" ref="form" v-model="formData"></avue-form>
    <FormTable ref="formTable" :formData="formData" :optionConfig="optionConfig"/>
    <span slot="dialog_footer" class="dialog-footer" v-if="!isDetails()">
      <el-button icon="el-icon-circle-plus-outline" type="primary" @click="submitForm()"
                 :disabled="loading">提交</el-button>
      <el-button icon="el-icon-circle-close" @click="$emit('handleClose')" :disabled="loading">取消</el-button>
    </span>
    <SelectPlan ref="selectPlan" @replace="replace"></SelectPlan>
  </div>
</template>

<script>
import {add, update, getDetail} from "../api";
import {disposeDetail, showItem, rulesInput} from '@/basic-common/util/common.js';
import SelectPlan from '@/views/railway-management/arrivalnoteplan/components/select-plan.vue';

export default {
  components: {SelectPlan},
  props: {
    transmitData: {
      required: true,
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      visible: false,
      title: '',
      show: false,
      loading: false,
      formData: {
        list: [{}]
      },
      optionForm: {
        ...this.$store.state.formOption,
        submitBtn: false,
        emptyBtn: false,
        detail: this.isDetails(), //启用form详情样式
        labelWidth: 150,
        column: [
          {
            label: "检查表编号",
            prop: "checkListCode",
            span: 24,
            display: showItem(
              {add: false, edit: false, view: true},
              this.transmitData.type
            ),
          },
          {
            label: "检查表名称",
            prop: "checkListName",
            span: 24,
            rules: rulesInput(1),
            rulesMessage: "检查表名称是必填项，请输入检查表名称"
          },
          {
            label: "检查表编号",
            prop: "checkListCode",
            span: 12,
            display: showItem(
              {add: false, edit: false, view: true},
              this.transmitData.type
            ),
          },
          {
            label: "检查类型",
            prop: "checkType",
            dicUrl: '/api/produce/safey-type/select/querySafeyType?safeyType=1',
            dataType: 'string',
            type: "select",
            props: {
              label: "typeName",
              value: "typeCode"
            },
            rules: rulesInput(1),
            rulesMessage: "请选择检查类型"
          },
          {
            label: "状态",
            prop: "status",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=enable_flag",
            dataType: 'string',
            type: "select",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            display: showItem(
              {add: false, edit: false, view: true},
              this.transmitData.type
            ),
          },
          {
            label: "最新更新人",
            prop: "updateName",
            overHidden: true,
            width: 100,
            display: showItem(
              {add: false, edit: false, view: true},
              this.transmitData.type
            ),
          },
          {
            label: "更新时间",
            prop: "updateTime",
            overHidden: true,
            width: 180,
            display: showItem(
              {add: false, edit: false, view: true},
              this.transmitData.type
            ),
          },
          {
            label: '责任部门',
            prop: 'applicableScope',
            overHidden: true, // 表格超出隐藏
            search: true, // 查询是否显示
            type: 'select',
            dicUrl: '/api/produce/blade-dept/select/deptSelect',
            props: {
              label: 'deptName',
              value: 'id'
            },
          },
          {
            label: "描述",
            prop: "remark",
            type: "textarea",
            maxlength: 200,
            span: 24,
            minRows: 2,
          },
        ]
      },
      list: [],
      optionConfig: {
        columnType: this.transmitData.type,
        addBtn: true,
        addText: '新增检查项',
        align: 'center',
        height: '40vh',
        column: [{
          label: '检查项目',
          prop: 'itemName',
          required: true,
        },
          {
            label: '检查标准/依据',
            prop: 'checkListStandard',
            type: "textarea",
            required: true,
            maxlength: 200,
          },
          {
            label: '必查项',
            prop: 'isRequired',
            type: 'switch',
          }
        ]
      }
    }
  },
  created() {
    const {type, id} = this.transmitData
    type !== 'add' && this.getDetail(id)
  },
  methods: {
    //提交
    async submitForm() {
      console.log(this.formData, 'this.formData09876');

      const list = this.formData.list
      const {type} = this.transmitData
      if (!list.length) {
        return this.$message.error('请录入表格数据并验证必填项')
      }
      const subFormValidate = await this.$refs.formTable.getValidate()
      this.$refs.form.validate((valid, done) => {
        if (valid && subFormValidate) {
          if (type == 'add') {
            add(this.formData).then(({data}) => {
              this.$emit('handleClose', 'refresh')
              this.$message({
                type: 'success',
                message: data.msg,
              })
            }).finally(() => {
              done()
            })
          } else {
            update(this.formData).then(({data}) => {
              this.$emit('handleClose', 'refresh')
              this.$message({
                type: 'success',
                message: data.msg,
              })
            }).finally(() => {
              done()
            })
          }
        } else {
          done()
          this.$message.error('错误, 请验证必填项并录入符合规则的数据')
        }
      })
    },
    // 回显信息初始化
    getDetail(id) {
      this.loading = true
      getDetail(id).then(res => {
        this.formData = res.data.data
        // 特殊处理详情 主表和子表， 禁用问题，悬浮提示问题。
        const topTier = this.$refs.madeForm
        this.isDetails() && disposeDetail(topTier)
        this.isDetails() && disposeDetail(topTier, 'table-details')
      }).finally(() => {
        this.loading = false
      })

    },
    // 是否是详情
    isDetails() {
      return this.transmitData.type && this.transmitData.type == 'view'
    },
    replace(row) {
      const replaceKey = ['planNo', 'planName', 'custNo', 'trainNumber', 'cargoName', 'cargoNo', 'contractName', 'contractNo']
      replaceKey.forEach(item => {
        this.$set(this.formData, item, row[item])
      });
    }
  }
}
</script>
<style scoped lang="scss"></style>
